// extracted by mini-css-extract-plugin
module.exports = {"productCardWrapper":"v1_productCardWrapper__Mtggq"};